import RouterOutlined from "@mui/icons-material/RouterOutlined";
import SettingsEthernetOutlined from "@mui/icons-material/SettingsEthernetOutlined";
import DnsOutlined from "@mui/icons-material/DnsOutlined";
import WifiOutlined from "@mui/icons-material/WifiOutlined";
import LocalFireDepartmentOutlined from "@mui/icons-material/LocalFireDepartmentOutlined";
import StorageOutlined from "@mui/icons-material/StorageOutlined";
import CloudOutlined from "@mui/icons-material/CloudOutlined";
import CellTowerOutlined from "@mui/icons-material/CellTowerOutlined";
import LanguageOutlined from "@mui/icons-material/LanguageOutlined";
import LocationCityOutlined from "@mui/icons-material/LocationCityOutlined";
import VpnKeyOutlined from "@mui/icons-material/VpnKeyOutlined";
import AccountTreeOutlined from "@mui/icons-material/AccountTreeOutlined";
import PersonOutlined from "@mui/icons-material/PersonOutlined";
import LanOutlined from "@mui/icons-material/LanOutlined";
import ExtensionOutlined from "@mui/icons-material/ExtensionOutlined";

// Catálogo de tipos de equipamento disponíveis na paleta do diagrama
const EQUIPMENT_TYPES = [
  { id: "roteador", label: "Roteador", icon: RouterOutlined },
  { id: "switch", label: "Switch", icon: SettingsEthernetOutlined },
  { id: "olt", label: "OLT", icon: DnsOutlined },
  { id: "cpe", label: "CPE / ONU", icon: WifiOutlined },
  { id: "firewall", label: "Firewall", icon: LocalFireDepartmentOutlined },
  { id: "servidor", label: "Servidor", icon: StorageOutlined },
  { id: "nuvem", label: "Nuvem", icon: CloudOutlined },
  { id: "radio", label: "Rádio", icon: CellTowerOutlined },
  { id: "internetUpstream", label: "Internet / Upstream", icon: LanguageOutlined },
  { id: "sitePop", label: "Site / PoP", icon: LocationCityOutlined },
  { id: "vpn", label: "VPN", icon: VpnKeyOutlined },
  { id: "vlanSubredeVrf", label: "VLAN / Sub-rede / VRF", icon: AccountTreeOutlined },
  { id: "clienteEndpoint", label: "Cliente / Endpoint", icon: PersonOutlined },
  { id: "servicoRede", label: "Serviço de rede", icon: LanOutlined },
  { id: "outroPersonalizado", label: "Outro / Personalizado", icon: ExtensionOutlined },
];

// Busca um tipo de equipamento pelo id numa lista (mesclada ou não); sem lista, busca só nos fixos
const getEquipmentType = (id, lista) =>
  (lista || EQUIPMENT_TYPES)?.find((tipo) => tipo?.id === id);

// Adapta um registro de anexo (tabela genérica Anexos, type "equipamento_personalizado")
// para o mesmo formato dos tipos fixos, permitindo tratamento uniforme na paleta/nó/inspector.
// iconUrl é resolvido sob demanda (ver customEquipmentTypesService) e mesclado aqui quando disponível.
const adaptCustomEquipmentType = (anexo) => ({
  id: anexo?.id,
  label: anexo?.descricao || anexo?.nome || "Personalizado",
  icon: null,
  isCustom: true,
  iconAnexoId: anexo?.id,
  iconUrl: anexo?.iconUrl || null,
});

// Mescla os tipos fixos com os personalizados (globais, buscados via customEquipmentTypesService)
const mergeEquipmentTypes = (customTypes = []) => [
  ...EQUIPMENT_TYPES,
  ...(customTypes || []).map((tipo) =>
    tipo?.isCustom ? tipo : adaptCustomEquipmentType(tipo),
  ),
];

export default EQUIPMENT_TYPES;
export { getEquipmentType, adaptCustomEquipmentType, mergeEquipmentTypes };
